import { Vue } from 'vue-property-decorator';
import Component from 'vue-class-component';
import { Notification } from '@/core/interfaces/notification';
import NotificationModal from '@/components/run/NotificationModal.vue';

@Component
export default class OpensNotificationModal extends Vue {
    async openNotificationModal(notification: Notification, closedFn?: () => {}): Promise<void> {
        this.$modal.show(
            NotificationModal,
            { notification },
            { adaptive: true, height: 'auto', width: '95%', shiftY: 0.05 },
            {
                closed: () => closedFn ? closedFn() : undefined,
            },
        );
    }
}
